import { Box } from '@material-ui/core';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

export const HomeHeader = ({ username }: { username: string }) => {
  return (
    <Box mb={3} minHeight={60}>
      <Font className="overflow-text-ellipsis" style={{ whiteSpace: 'break-spaces' }} variant={'h2'} color={'title'}>
        <Text tId={'WELCOME_TO_PANEL'} dynamicDataTexts={[username]} />
      </Font>
    </Box>
  );
};
